import React, { FC, ReactElement } from 'react';
import { Filter, ResourceComponentProps, TextInput } from 'react-admin';
import { ResourceName } from 'types/resources';

export const CheckupsFilter: FC<ResourceComponentProps> = (props): ReactElement => (
  <Filter {...props}>
    <TextInput key="name" source={`${ResourceName.CHECKUPS}.filter`} label="Search by name" alwaysOn />
  </Filter>
);
